export const getStructuredData = (baseUrl) => {
  const siteUrl = baseUrl || (typeof window !== 'undefined' ? window.location.origin : '');
  
  return {
  // Organization Schema
  organization: {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": `${siteUrl}/#organization`,
    "name": "Alpielec",
    "url": siteUrl,
    "logo": `${siteUrl}/images/logo-alpielec.png`,
    "image": `${siteUrl}/images/logo-alpielec.png`,
    "description": "Expert en travaux d'électricité et cordiste professionnel au Pays Basque",
    "telephone": "+33610952631",
    "email": "contact@alpielec.fr",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Urrugne",
      "addressRegion": "Nouvelle-Aquitaine",
      "postalCode": "64122",
      "addressCountry": "FR"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "43.3636",
      "longitude": "-1.6992"
    },
    "areaServed": {
      "@type": "GeoCircle",
      "geoMidpoint": {
        "@type": "GeoCoordinates",
        "latitude": "43.3636",
        "longitude": "-1.6992"
      },
      "geoRadius": "50000"
    },
    "priceRange": "€€",
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday"
        ],
        "opens": "00:00",
        "closes": "23:59"
      }
    ],
    "sameAs": []
  },

  // Services Schema - Electrician
  electricianService: {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "Électricien",
    "provider": {
      "@type": "LocalBusiness",
      "name": "Alpielec"
    },
    "areaServed": {
      "@type": "Place",
      "name": "Pays Basque"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Services Électricien",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Remises en Conformité Électrique",
            "description": "Mise aux normes de vos installations électriques selon les réglementations en vigueur"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Dépannage Électrique",
            "description": "Intervention rapide pour tous vos problèmes électriques, 7j/7"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Rénovation Électrique",
            "description": "Rénovation complète de vos installations électriques anciennes"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Travaux Électriques Neufs",
            "description": "Installation électrique complète pour constructions neuves"
          }
        }
      ]
    }
  },

  // Services Schema - Rope Access
  ropeAccessService: {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "Cordiste - Travaux en Hauteur",
    "provider": {
      "@type": "LocalBusiness",
      "name": "Alpielec"
    },
    "areaServed": {
      "@type": "Place",
      "name": "Pays Basque"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Services Cordiste",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Travaux Haute Tension",
            "description": "Intervention sur installations électriques haute tension en hauteur avec sécurité maximale"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Relamping en Hauteur",
            "description": "Remplacement et maintenance d'éclairages en hauteur, optimisation énergétique par accès sur corde"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Reprise de Maçonnerie",
            "description": "Travaux de maçonnerie en hauteur, réparation et rénovation de façades"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Port de Charge en Hauteur",
            "description": "Manutention et transport de charges en hauteur en toute sécurité"
          }
        }
      ]
    }
  },

  // Breadcrumb Schema
  breadcrumb: (items) => ({
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": item.url
    }))
  }),

  // Reviews Schema
  reviews: {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Alpielec",
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5",
      "bestRating": "5",
      "worstRating": "1",
      "ratingCount": "5"
    },
    "review": [
      {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": "Caroline Zarza"
        },
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        },
        "reviewBody": "Intervention rapide, travail soigné et très professionnel. M. Levot a été ponctuel et à l'écoute. Le chantier a été laissé propre et les délais ont été respectés. Un service de qualité avec un bon rapport qualité/prix."
      },
      {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": "Louis Roussel"
        },
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        },
        "reviewBody": "Je recommande! François a été très professionnel et consciencieux et a répondu à toutes nos attentes pour mener à bien notre projet de rénovation"
      },
      {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": "Geoffrey"
        },
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        },
        "reviewBody": "Un grand merci à François pour le travail réalisé. Réactif, dynamique et sérieux, nous sommes ravis d'avoir choisi François pour réaliser notre installation électrique. Un artisan que je recommande les yeux fermés !"
      },
      {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": "Quentin Avril"
        },
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        },
        "reviewBody": "Faire appel à ALPIELEC, c'est travailler avec un professionnel aguerri, de très bon conseils et qui pratique un tarif cohérent. Qui plus est, François est très sympathique. Nous le recommandons vivement !"
      },
      {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": "Marie-Liesse Couette"
        },
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        },
        "reviewBody": "Merci François pour ton travail chez nous. En plus, ce n'est pas faute de t'avoir fait revenir à plusieurs étapes du chantier global et tu t'es toujours arrangé! Merci de nous avoir fait découvrir les boutons à distance. Et merci aussi pour ton écoute et ton dynamisme."
      }
    ]
  },

  // FAQ Schema
  faq: {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Intervenez-vous chez les particuliers et les professionnels ?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Oui, absolument ! J'interviens auprès des particuliers, des professionnels (entreprises, commerces) et des copropriétés au Pays Basque. Mes deux activités (électricien et cordiste) sont proposées pour tous types de clientèle."
        }
      },
      {
        "@type": "Question",
        "name": "Quelles sont vos zones d'intervention au Pays Basque ?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Basé à Urrugne, j'interviens dans tout le Pays Basque : Bayonne, Biarritz, Anglet, Saint-Jean-de-Luz, Hendaye, Ciboure, Bidart, Guéthary, Ascain, Sare, et toutes les communes environnantes."
        }
      },
      {
        "@type": "Question",
        "name": "Proposez-vous les deux services en même temps ?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Oui ! Je peux intervenir uniquement en tant qu'électricien, uniquement en tant que cordiste, ou combiner les deux métiers pour des projets nécessitant des travaux électriques en hauteur."
        }
      },
      {
        "@type": "Question",
        "name": "Êtes-vous disponible pour les dépannages urgents ?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Oui, je suis disponible 7j/7 pour tous vos dépannages électriques urgents au Pays Basque. Intervention rapide à Urrugne, Bayonne, Biarritz et environs."
        }
      },
      {
        "@type": "Question",
        "name": "Vos devis sont-ils gratuits ?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Oui, tous mes devis sont totalement gratuits et sans engagement, que ce soit pour des travaux d'électricité, des travaux en hauteur, ou une combinaison des deux."
        }
      }
    ]
  }
};
};
